/**
 * UI adapter: UC-44 LoadTooltipContent
 */
import { architectureFeatures } from '../../../infrastructure/config/features';
import { loadTooltipContentUseCase } from '../../../infrastructure/di/container';
import { LoadTooltipContentUseCase } from '../../../application/use-cases/LoadTooltipContentUseCase';
import { tooltipContentService } from '../../../../services/tooltipContentService';

export async function resolveLoadTooltipContent(): Promise<{ ok: boolean; ready: boolean }> {
  if (architectureFeatures.useTooltipContentUseCase) {
    const result = await loadTooltipContentUseCase.execute();
    return { ok: result.ok, ready: result.ready };
  }

  await tooltipContentService.initialize();
  return { ok: true, ready: tooltipContentService.isInitialized() };
}